/**
 * 返回url中参数
 */
export const getUrlParams = (() => {
  const path = window.location.href
  let params = ''
  let res = {}
  return function () {
    if (!path.match(/\?/)) return {}
    params = path.split('?')[1].split('#')[0].split('&')
    if (JSON.stringify(res) === '{}') {
      res = params.reduce((obj, item) => {
        obj[item.split('=')[0]] = item.split('=')[1]
        return obj
      }, {})
    }
    return res
  }
})()

/**
 * 获取深层对象，如不存在则返回 undefined
 * @param {Array} a 键数组
 * @param {Object} o 要获取值的对象
 */
export const getDeepObj = (a, o) => (a.reduce((r, i) => (r && r[i]), o))

/**
 * 时间戳转日期
 * @param {Number} timestamp 时间戳
 * @return {String} date 日期
 */
export const timestampToTime = (timestamp) => {
  let date = new Date(timestamp * 1000)
  let Y = date.getFullYear() + '-'
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + M + D + h + m + s
}

/**
 * 左侧列表显示时间
 * 如本年则显示月日，如非本年，则显示年份
 * @param {Number} timestamp 时间戳
 */
export const formatListDate = (timestamp) => {
  let thisDate = new Date()
  let matchDate = new Date(timestamp)
  let thisDay = thisDate.getDate()
  let matchDay = matchDate.getDate()
  let thisMonth = thisDate.getMonth()
  let matchMonth = matchDate.getMonth()
  let thisYear = thisDate.getFullYear()
  let matchYear = matchDate.getFullYear()

  let matchM = (matchDate.getMonth() + 1 < 10 ? '0' + (matchDate.getMonth() + 1) : matchDate.getMonth() + 1) + '-'
  let matchD = (matchDate.getDate() < 10 ? '0' + matchDate.getDate() : matchDate.getDate())

  let matchHour = matchDate.getHours() < 10 ? '0' + matchDate.getHours() : matchDate.getHours()
  let matchMin = matchDate.getMinutes() < 10 ? '0' + matchDate.getMinutes() : matchDate.getMinutes()

  if (thisYear === matchYear && thisMonth === matchMonth && thisDay === matchDay) {
    return matchHour + ':' + matchMin
  } else {
    return matchYear + '-' + matchM + matchD
  }
}

/**
 * 时间戳转过去了的时间长度
 * @param {Number} timestamp 时间戳
 * @return {String} result 过去的时间或日期
 */
export const timeAgo = (timestamp) => {
  let minute = 1000 * 60
  let hour = minute * 60
  let day = hour * 24
  let week = day * 7
  // let halfAMonth = day * 15
  let month = day * 30
  let now = new Date().getTime()
  let diffValue = now - timestamp
  let result

  if (diffValue < 0) {
    return
  }
  let minC = Math.floor(diffValue / minute)
  let hourC = Math.floor(diffValue / hour)
  let dayC = Math.floor(diffValue / day)
  let weekC = Math.floor(diffValue / week)
  let monthC = Math.floor(diffValue / month)
  if (monthC >= 1 && monthC <= 3) {
    result = ' ' + parseInt(monthC) + '月前'
  } else if (weekC >= 1 && weekC <= 3) {
    result = ' ' + parseInt(weekC) + '周前'
  } else if (dayC >= 1 && dayC <= 6) {
    result = ' ' + parseInt(dayC) + '天前'
  } else if (hourC >= 1 && hourC <= 23) {
    result = ' ' + parseInt(hourC) + '小时前'
  } else if (minC >= 1 && minC <= 59) {
    result = ' ' + parseInt(minC) + '分钟前'
  } else if (diffValue >= 0 && diffValue <= minute) {
    result = '刚刚'
  } else {
    let datetime = new Date()
    datetime.setTime(timestamp)
    let Nyear = datetime.getFullYear()
    let Nmonth = datetime.getMonth() + 1 < 10 ? '0' + (datetime.getMonth() + 1) : datetime.getMonth() + 1
    let Ndate = datetime.getDate() < 10 ? '0' + datetime.getDate() : datetime.getDate()
    // let Nhour = datetime.getHours() < 10 ? '0' + datetime.getHours() : datetime.getHours()
    // let Nminute = datetime.getMinutes() < 10 ? '0' + datetime.getMinutes() : datetime.getMinutes()
    // let Nsecond = datetime.getSeconds() < 10 ? '0' + datetime.getSeconds() : datetime.getSeconds()
    result = Nyear + '-' + Nmonth + '-' + Ndate
  }
  return result
}

/**
 * 获取当前时间各字段拼接
 * @return {String} date 日期
 */
export const getDateText = () => {
  let date = new Date()
  let Y = date.getFullYear()
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
  let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
  let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
  return `${Y}${M}${D}${h}${m}`
}

/**
 * 填补0
 * @param {String|Number} num 要填补0的数字
 */
export const fillZero = (num) => {
  num = parseInt(num)
  return num < 10 ? '0' + num : num
}

/**
 * 保持参数跳转
 * @param {Object} self vue 对象
 * @param {Object} opt 跳转的参数
 */
export const jumpKeepQuery = (self, opt, path = '') => {
  let query = Object.assign({}, self.$route.query, opt)
  self.$router.push({path: path, query: query})
}

/**
 * 解析机器人交互数据
 * @param {String} cont 文章内容
 * @param {Array} Q
 * @param {Array} R 机器人问句
 */
export const robotExplain = (cont, Q, R) => {
  if (R.length === 0) return cont
  let d = document.createDocumentFragment()
  let contWrapDom = document.createElement('div')
  contWrapDom.id = 'contWrap'
  d.appendChild(contWrapDom)
  let contWrap = d.getElementById('contWrap')
  contWrap.innerHTML = cont
  R.map(item => {
    let p = contWrap.getElementsByTagName('p')[parseInt(item.paragraph_pos) - 1]
    let pText = p.innerText
    let sArr = pText.split('。')
    let sIndex = parseInt(item.sentence_pos)
    let nextS = sArr[sIndex] || ''
    let opeWrap = `<span class="robotWord">${item.query_content}</span>`
    sArr[sIndex] = opeWrap + nextS
    p.innerHTML = sArr.join('。')
  })
  cont = contWrap.innerHTML
  // console.group('格式化内容')

  // console.log(cont)
  // console.log(Q)
  // console.log(R)
  // console.log(d.innerHTML)
  // console.log(d)
  // console.log(contWrap)

  // console.groupEnd('格式化内容')
  return cont
}

/**
 * 识别文章中个股，并标注，点击后跳转客户端分时
 * @param {String} cont 文章内容
 * @param {Array} stockList 个股数组
 */
export const symbolStock = (cont, stockList) => {
  stockList.map(item => {
    let reg = new RegExp(item.name, 'g')
    cont = cont.replace(reg, function (name) {
      return `<a class="stockWord" href="hxa://hexin.exe 'opt=13&param=${item.code}|'/">${name}</a>`
    })
  })
  return cont
}

/**
 * 识别文章中newsstocks
 * @param {String} cont 文章内容
 * @param {Object} newsstocks 个股数组
 */
export const symbolNewsStocks = (cont, newsstocks) => {
  let stockArr = []
  for (let item in newsstocks) {
    stockArr.push({
      name: newsstocks[item],
      code: item
    })
  }
  stockArr.map(item => {
    let reg = new RegExp(item.name, 'g')
    cont = cont.replace(reg, function (name) {
      return `<a class="stockWord" href="hxa://hexin.exe 'opt=13&param=${item.code}|'/">${name}</a>`
    })
  })
  return cont
}

export const isLogin = () => {
  // eslint-disable-next-line
  console.log('getAccount-------', getAccount())
  return !!getAccount()
}
